import './TagsInput.scss'
import TagsInputCore from 'react-tagsinput'
import React from 'react'

export const TagsInput = ({ disabled, value, onChange, submitting, ...rest }: any) => {
  const internalValue = React.useMemo(() => value || [], [value])

  disabled = disabled || submitting

  return (
    <TagsInputCore
      className={`react-tagsinput ${disabled ? 'react-tagsinput-disabled' : ''}`}
      {...{ ...rest, value: internalValue, onChange }}
      disabled={disabled}
    />
  )
}
